import { Bubbles } from '@gobistories/gobi-web-integration';

import {
  EventInfoAction,
  EventInfoCategory,
  trackTradidionalGaEvent,
} from '@/components/GoogleTagManager';

export const createBubble = (
  container: string,
  storiesAsString: string,
  bubbleSize: string,
  wrap: boolean = true,
  showPlayIcon: boolean = false,
  autoStart: boolean = false,
  animatedBubble: boolean = false,
  autoStartWithSound: boolean = false,
) => {
  if (!storiesAsString) {
    return;
  }
  const storiesArray = storiesAsString.split(' ');
  if (storiesArray.length === 0) {
    return;
  }
  // create a array the way Bubble expects it
  const stories = storiesArray.map((story) => {
    return {
      id: story,
    };
  });
  new Bubbles({
    container,
    bubbleSize,
    color: '#1F9DC9',
    stories,
    wrap,
    inheritTextFontFamily: true,
    titleFontSize: '16px',
    showPlayIcon,
    animatedBubble,
    playerOptions: {
      autoStart,
      autoStartWithSound,
    },
  });

  trackTradidionalGaEvent(
    EventInfoCategory.GobiBubbles,
    EventInfoAction.Displayed,
    'Component loaded',
    storiesAsString,
  );
};

// Initialize all bubbles on the page
document.querySelectorAll('.gobibubbles').forEach(function (bubbleDiv) {
  const container = '#' + bubbleDiv.getAttribute('id');
  const storiesString = bubbleDiv.getAttribute('data-gobi-stories') || '';
  const size = bubbleDiv.getAttribute('data-gobi-bubble-size') || '150px';

  const wrapAttr = bubbleDiv.getAttribute('data-gobi-wrap') || 'true';
  const wrap = wrapAttr === 'true' || wrapAttr === 'True' ? true : false;

  const showPlayIconAttr =
    bubbleDiv.getAttribute('data-gobi-show-play-icon') || 'false';
  const showPlayIcon =
    showPlayIconAttr === 'true' || showPlayIconAttr === 'True' ? true : false;

  const autoStartAttr =
    bubbleDiv.getAttribute('data-gobi-auto-start') || 'false';
  const autoStart =
    autoStartAttr === 'true' || autoStartAttr === 'True' ? true : false;

  const animatedAttr =
    bubbleDiv.getAttribute('data-gobi-animated-bubble') || 'false';
  const animated =
    animatedAttr === 'true' || animatedAttr === 'True' ? true : false;

  const autoStartWithSoundAttr =
    bubbleDiv.getAttribute('data-gobi-auto-start-with-sound') || 'false';
  const autoStartWithSound =
    autoStartWithSoundAttr === 'true' || autoStartWithSoundAttr === 'True'
      ? true
      : false;

  createBubble(
    container,
    storiesString,
    size,
    wrap,
    showPlayIcon,
    autoStart,
    animated,
    autoStartWithSound,
  );
});
